import { useNotificationSocket } from "./useNotificationSocket";

const NotificationComponent = () => {
  const { draftOrderUpdates } = useNotificationSocket();
  const notifyCount = draftOrderUpdates.length;

  // Debug — remove once confirmed working
  console.log("[NotificationComponent] count:", notifyCount);

  if (notifyCount === 0) return null;

  return (
    <div
      className="bg-green-600 text-white text-xs font-semibold w-5 h-5 flex items-center justify-center rounded-full absolute -top-1 -right-1 pointer-events-none"
      aria-label={`${notifyCount} new draft order updates`}
    >
      {notifyCount > 99 ? "99+" : notifyCount}
    </div>
  );
};

export default NotificationComponent;